// extracted by mini-css-extract-plugin
module.exports = {"home":"index-module--home--1rW0p","home__logoImage":"index-module--home__logo-image--1jL_c","coverImage":"index-module--coverImage--1evzO"};